// LICENSE_CODE ZON
'use strict';
/*jslint browser:true, es6:true, node:true, react:true*/

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import _ from 'zutil';
import hopt from 'hola_opt';
import zutil from '/util/util.js';
import { get_icon, use_scrolled, is_scrolled_down } from '../ui_utils.js';
import { use_screen } from '../lib/screen_util.ts';
import { Sitepic } from '../unblock/sitepic.js';
import styles from './popular_sitepics.module.less';
const cols_count = {
  xs: 2,
  sm: 3,
  md: 4,
  lg: 5,
  xl: 5
};

const get_vars_object = (props, cols) => {
  const row_gap = props.row_gap,
        col_gap = props.col_gap;
  const n_style_vars = {
    '--count_col': cols,
    '--opacity_val': 1
  };
  if (row_gap) n_style_vars['--row_gap'] = `${row_gap}px`;
  if (col_gap) n_style_vars['--col_gap'] = `${col_gap}px`;
  return n_style_vars;
};

const with_promotions = (sitepics, promotions) => {
  const result = sitepics.slice();
  promotions.filter(({
    show
  }) => show).forEach(({
    pos,
    promo
  }, i) => {
    result.splice(pos + i, 0, {
      promo
    });
  });
  return result;
};

const Popular_sitepics = props => {
  useTranslation();
  const limit = props.limit,
        sitepics = props.sitepics,
        sitepics_generic = props.sitepics_generic,
        _props$promotions = props.promotions,
        promotions = _props$promotions === void 0 ? [] : _props$promotions,
        add_on_scroll = props.add_on_scroll,
        active = props.active,
        header = props.header,
        _props$on_get_more = props.on_get_more,
        on_get_more = _props$on_get_more === void 0 ? _.noop : _props$on_get_more,
        img_load_delay = props.img_load_delay,
        activate = props.activate,
        filter = props.filter,
        row_gap = props.row_gap,
        col_gap = props.col_gap,
        cls = props.cls,
        with_column = props.with_column,
        scale = props.scale,
        elem = props.elem,
        requester = props.requester,
        no_more_button = props.no_more_button,
        page = props.page;
  const Item_el = elem || Sitepic;
  const items = with_promotions(sitepics, promotions);

  const _use_screen = use_screen(),
        screen = _use_screen.screen,
        is_client = _use_screen.is_client;

  const cols = (props.cols_count || cols_count)[screen];
  const siteicon = zutil.get(hopt, 'www_hola.siteicon.enabled');
  const icon_sources = [link => get_icon(link, siteicon, sitepics_generic && requester)];
  const t_ref = useRef();

  const _use_scrolled = use_scrolled(),
        direction = _use_scrolled.direction,
        _use_scrolled$y = _use_scrolled.y,
        y = _use_scrolled$y === void 0 ? 0 : _use_scrolled$y;

  useEffect(() => {
    if (!add_on_scroll || limit >= items.length || direction == 'up') return;
    if (t_ref && is_scrolled_down(t_ref.current, 100)) on_get_more();
  }, [y]);
  useEffect(() => {
    if (!scale || !t_ref.current) return;
    t_ref.current.style.transform = `scale(${scale})`;
    t_ref.current.style.transformOrigin = '0 0';
  }, [t_ref.current, scale]);
  const use_isomorphic_layout_effect = is_client ? useLayoutEffect : useEffect;
  use_isomorphic_layout_effect(() => {
    if (!scale || !t_ref.current || limit < 10) return;
    const h = t_ref.current.getBoundingClientRect().height;
    t_ref.current.style.marginBottom = `-${h * (1 - scale)}px`;
  }, [limit, scale]);

  const _useState = useState(with_column ? get_vars_object(props, cols) : {}),
        _useState2 = _slicedToArray(_useState, 2),
        style_vars = _useState2[0],
        set_style_vars = _useState2[1];

  useEffect(() => set_style_vars(get_vars_object(props, cols)), [cols, row_gap, col_gap]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.wrapper, cls)
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.grid, header && styles.with_header),
    ref: t_ref,
    style: style_vars
  }, header && /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, header), items.map((s, i) => {
    if (s.promo) {
      return /*#__PURE__*/React.createElement(Item_el, {
        key: `${i}-promo`,
        promo: s.promo,
        is_generic: sitepics_generic,
        requester: true
      });
    }

    if (!filter && !add_on_scroll && limit <= items.length && i == limit && !no_more_button) {
      return /*#__PURE__*/React.createElement(Item_el, {
        title: "More",
        more: true,
        filter: true,
        key: `${i}-more`,
        on_get_more: on_get_more,
        cls: styles.tile,
        is_generic: sitepics_generic,
        requester: true
      });
    }

    if (i > limit) return null;
    const unblocking = active && active.link == s.link;
    return /*#__PURE__*/React.createElement(Item_el, _extends({
      key: `${i}-${s.name}`
    }, s, {
      is_generic: sitepics_generic,
      requester: true,
      page: page,
      img_load_delay: img_load_delay || 100,
      activate: activate,
      unblocking: unblocking,
      cls: styles.tile,
      disabled: active && !unblocking,
      icon_sources: icon_sources
    }));
  })));
};

export { Popular_sitepics };